module.exports = __webpack_public_path__ + "static/media/createIcon.52b20824.svg";